import { AllPlanning } from './components/all-planning';

export function AllProductsContent() {
  return <AllPlanning />;
}
